/* Kanwall Arts — theme.js (vanilla JS only) */
(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initSearchDrawer();
    initProductGalleries();
    initSizeSelectors();
    initQuantitySelectors();
    initReviewSliders();
    initCarousels();
  });

  /* ---------- Mobile nav drawer ---------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-menu-toggle]");
    var drawer = document.querySelector("[data-mobile-nav]");
    var close = document.querySelector("[data-mobile-nav-close]");
    if (!toggle || !drawer) return;
    toggle.addEventListener("click", function () {
      drawer.classList.add("is-open");
      document.body.style.overflow = "hidden";
    });
    if (close) {
      close.addEventListener("click", function () {
        drawer.classList.remove("is-open");
        document.body.style.overflow = "";
      });
    }
  }

  /* ---------- Predictive search drawer ---------- */
  function initSearchDrawer() {
    var openBtn = document.querySelector("[data-search-toggle]");
    var drawer = document.querySelector("[data-search-drawer]");
    var closeBtn = document.querySelector("[data-search-close]");
    if (!openBtn || !drawer) return;
    openBtn.addEventListener("click", function () {
      drawer.classList.add("is-open");
      var input = drawer.querySelector("input[type='search']");
      if (input) setTimeout(function () { input.focus(); }, 50);
    });
    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        drawer.classList.remove("is-open");
      });
    }
    drawer.addEventListener("click", function (e) {
      if (e.target === drawer) drawer.classList.remove("is-open");
    });
  }

  /* ---------- Product image gallery ---------- */
  function initProductGalleries() {
    document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
      var slides = gallery.querySelectorAll("[data-gallery-slide]");
      var thumbs = gallery.querySelectorAll("[data-gallery-thumb]");
      var prev = gallery.querySelector("[data-gallery-prev]");
      var next = gallery.querySelector("[data-gallery-next]");
      var index = 0;

      function show(i) {
        if (i < 0) i = slides.length - 1;
        if (i >= slides.length) i = 0;
        index = i;
        slides.forEach(function (s, si) { s.classList.toggle("is-active", si === index); });
        thumbs.forEach(function (t, ti) { t.classList.toggle("is-active", ti === index); });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () { show(i); });
      });
      if (prev) prev.addEventListener("click", function () { show(index - 1); });
      if (next) next.addEventListener("click", function () { show(index + 1); });

      if (slides.length) show(0);
    });
  }

  /* ---------- Variant / size selectors ---------- */
  function initSizeSelectors() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var wrapper = form.closest(".product-info") || form.parentElement;
      var variantInput = form.querySelector("[data-variant-id]");
      var sizeButtons = form.querySelectorAll("[data-size-option]");
      var priceEls = wrapper ? wrapper.querySelectorAll("[data-product-price]") : [];
      var selectedLabel = form.querySelector("[data-selected-size-label]");
      var addBtn = form.querySelector("[data-add-to-cart]");
      var buyBtn = form.querySelector("[data-buy-now]");
      var sticky = document.querySelector(".sticky-cta");
      var stickyPrice = sticky ? sticky.querySelector("[data-product-price]") : null;

      function updatePrice(price, comparePrice) {
        Array.prototype.forEach.call(priceEls, function (el) { el.textContent = price || ""; });
        if (stickyPrice) stickyPrice.textContent = price || "";

        var compareEls = wrapper ? wrapper.querySelectorAll(".compare-at") : [];
        Array.prototype.forEach.call(compareEls, function (el) {
          if (comparePrice && comparePrice !== price) {
            el.textContent = comparePrice;
            el.style.display = "";
          } else {
            el.style.display = "none";
          }
        });
      }

      sizeButtons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          if (btn.disabled) return;

          sizeButtons.forEach(function (b) { b.classList.remove("is-selected"); });
          btn.classList.add("is-selected");

          var variantId = btn.getAttribute("data-variant-id");
          var available = btn.getAttribute("data-available") === "true";
          var price = btn.getAttribute("data-price");
          var comparePrice = btn.getAttribute("data-compare-price");
          var sizeLabel = btn.getAttribute("data-size-label") || btn.getAttribute("data-size-value") || btn.textContent.trim();

          if (variantInput) variantInput.value = variantId;
          if (selectedLabel) selectedLabel.textContent = sizeLabel;
          updatePrice(price, comparePrice);

          [addBtn, buyBtn].forEach(function (b) {
            if (!b) return;
            b.disabled = !available;
            b.textContent = available
              ? b.getAttribute("data-label-available")
              : b.getAttribute("data-label-unavailable");
          });

          form.dispatchEvent(new CustomEvent("variant:changed", {
            detail: { variantId: variantId, size: sizeLabel }
          }));
        });
      });
    });
  }

  /* ---------- Quantity selectors ---------- */
  function initQuantitySelectors() {
    // Product-page quantity controls only.
    // Cart quantities are handled by the cart-specific handler below so
    // each click results in exactly one Shopify cart update.
    document.querySelectorAll("[data-product-form] [data-qty-selector]").forEach(function (wrap) {
      var input = wrap.querySelector("input[name='quantity']");
      var minus = wrap.querySelector("[data-qty-minus]");
      var plus = wrap.querySelector("[data-qty-plus]");
      if (!input) return;

      if (minus) minus.addEventListener("click", function (e) {
        e.preventDefault();
        var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = v;
      });

      if (plus) plus.addEventListener("click", function (e) {
        e.preventDefault();
        var v = (parseInt(input.value, 10) || 1) + 1;
        input.value = v;
      });
    });
  }

  /* ---------- Review slider dots (mobile) ---------- */
  function initReviewSliders() {
    document.querySelectorAll("[data-reviews-slider]").forEach(function (section) {
      var track = section.querySelector("[data-reviews-track]");
      var dots = section.querySelectorAll("[data-review-dot]");
      if (!track || !dots.length) return;

      dots.forEach(function (dot, i) {
        dot.addEventListener("click", function () {
          var card = track.children[i];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: "smooth" });
        });
      });

      track.addEventListener("scroll", debounce(function () {
        var scrollLeft = track.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        Array.prototype.forEach.call(track.children, function (card, i) {
          var dist = Math.abs(card.offsetLeft - track.offsetLeft - scrollLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        dots.forEach(function (d, i) { d.classList.toggle("is-active", i === closest); });
      }, 100));
    });
  }

  /* ---------- Generic horizontal carousels (featured products, related) ---------- */
  function initCarousels() {
    document.querySelectorAll("[data-carousel-prev], [data-carousel-next]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var targetSel = btn.getAttribute("data-carousel-target");
        var track = document.querySelector(targetSel);
        if (!track) return;
        var amount = track.clientWidth * 0.8;
        track.scrollBy({ left: btn.hasAttribute("data-carousel-next") ? amount : -amount, behavior: "smooth" });
      });
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- Cart quantity change (cart page) ---------- */
  window.KanwallCart = {
    updateLine: function (line, quantity) {
      quantity = Math.max(0, parseInt(quantity, 10) || 0);

      return fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          line: parseInt(line, 10),
          quantity: quantity
        })
      }).then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || "Unable to update cart.");
          });
        }
        return response.json();
      }).then(function () {
        window.location.reload();
      }).catch(function (error) {
        console.error("Cart update failed:", error);
        window.location.reload();
      });
    }
  };
})();
